import Vue from "vue";
import { formatWithOptions, intervalToDuration, formatDurationWithOptions, parse } from "date-fns/fp";
import { es } from 'date-fns/locale';
import isString from "lodash/isString";


// format utilities
function toDate(value) {
    return isString(value) ? new Date(value) : value;
}

export const formatDateTime = (defaultFormat) => 
    (value, prettyFormat = defaultFormat) => {
        if(!value) return "-"

        const dateToFormat = toDate(value)
        return formatWithOptions({ locale: es }, prettyFormat)(dateToFormat)
    }

export const formatTime = formatDateTime("HH:mm")
Vue.filter("date", formatDateTime("dd/MM"))
Vue.filter("datetime", formatDateTime("dd/MM/yy HH:mm"))
Vue.filter("dayMonth", formatDateTime("d MMMM"))
Vue.filter("time", formatTime)
Vue.filter("dayWeek", formatDateTime("eeee"))


export const filterDuration = (defaultFormat) => 
    ({ start, end }, prettyFormat = defaultFormat) => {
        let duration = intervalToDuration({
            start: toDate(start),
            end: toDate(end)
        })
        
        return formatDurationWithOptions({ format: prettyFormat, locale: es })(duration)
    }

Vue.filter("duration", filterDuration(['days', 'hours', 'minutes']))


// parse utilities

const dateFormat = "yyyy-MM-dd";
export const parseDate = parse(new Date())(dateFormat);


